import styled from 'styled-components';
import { fadeIn, fadeOut } from '../../../js/animation';

interface StyledProps {
  isClose?: boolean;
}

export const ModalWrap = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999;
  overflow: hidden;
`;

const forwardCloseProp = (prop: string) => prop !== 'isClose';

export const ModalBackground = styled.div.withConfig({
  shouldForwardProp: forwardCloseProp,
})<StyledProps>`
  width: 100%;
  height: 100vh;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  animation: ${({ isClose }) => (isClose ? fadeIn : fadeOut)} 0.3s ease-in-out;
`;

export const ModalBox = styled.div.withConfig({
  shouldForwardProp: forwardCloseProp,
})<StyledProps>`
  width: 337px;
  min-height: 353px;
  background-color: var(--colWhite);
  border-radius: 22px;
  animation: ${({ isClose }) => (isClose ? fadeIn : fadeOut)} 0.3s ease-in-out;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 30;
  display: flex;
  flex-direction: column;
  padding: 0;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px 8px 20px;
  & button.close-button {
    margin-left: auto;
    width: 23px;
    height: 23px;
    background: none;
    border: none;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
`;

export const ModalBody = styled.div`
  padding: 0 35px 0 35px;
  .modal-title {
    width: 180px;
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 15px;
  }
  .modal-container {
    font-size: 17px;
    font-weight: 500;
    line-height: 20px;
    word-break: keep-all;
  }
`;

interface ModalFooterProps {
  isTall: boolean;
}

const forwardFooterProp = (prop: string) => prop !== 'isTall';

export const ModalFooter = styled.div.withConfig({
  shouldForwardProp: forwardFooterProp,
})<ModalFooterProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
  padding: ${({ isTall }) => (isTall ? '40px 35px 30px 35px' : '8px 35px 30px 35px')};
  margin-top: auto;
  .modal-footer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    button {
      width: 237px;
      padding: 15px 20px;
      background-color: #191919;
      border: none;
      border-radius: 100px;
      color: var(--colWhite);
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
    }
  }
`;
